/*
* @desc 校验用户名
* @param userName 用户名
* @returns Boolean 校验结果
* */
function verifyName(userName) {
  // var userNameIdentify = /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/;
  var userNameIdentify = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,15}$/;
  return userNameIdentify.test(userName);
}
/*
* @desc 校验手机号
* @param mobile 手机号
* @returns Boolean 校验结果
* */
function verifyPhone(mobile) {
  var mobileIdentify = /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9]|9[0-9]|6[0-9])\d{8}$/;
  // var mobileIdentify = /^((19[0-9])|(16[0-9])|(13[0-9])|(14[0-9])|(17[0-9])|(15[^4,\D])|(18[0-9]))\d{8}$/;
  return mobileIdentify.test(mobile);
}
/*
* @desc 校验6位数字验证码
* @param code 验证码
* @returns Boolean 校验结果
* */
function verifyCheckCode(code) {
  // 校验表达式
  var checkCodeIdentify = /\d{6}/;
  return checkCodeIdentify.test(code);
}
/*
* @desc 校验纯数字
* @param code 输入值
* @returns Boolean 校验结果
* */
function verifyPureNum (code) {
  var regExpression = /^[0-9]*$/;
  return regExpression.test(code);
}
/*
* @desc 校验身份证号码
*  @param id 身份证号码
* @returns Boolean 校验结果
* */
/*function verifyIDCard(code) {
  /!*var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  };
  /!* eslint-disable no-unused-vars *!/
  var tip = '';
  var pass = true;
  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/gi.test(code)) {
    tip = '身份证号格式错误';
    pass = false;
  } else if (!city[code.substr(0, 2)]) {
    tip = '地址编码错误';
    pass = false;
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length === 18) {
      code = code.split('');
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      if (parity[sum % 11] !== parseInt(code[17])) {
        tip = '校验位错误';
        pass = false;
      }
    }
  }
  return pass;*!/
}*/
function verifyIDCard(id) {
  // 1 "验证通过!", 0 //校验不通过
  var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  //号码规则校验
  if(!format.test(id)){
    // return {'status':0,'msg':'身份证号码不合规'};
    return false;
  }
  //区位码校验
  //出生年月日校验   前正则限制起始年份为1900;
  var year = id.substr(6,4),//身份证年
    month = id.substr(10,2),//身份证月
    date = id.substr(12,2),//身份证日
    time = Date.parse(month+'-'+date+'-'+year),//身份证日期时间戳date
    now_time = Date.parse(new Date()),//当前时间戳
    dates = (new Date(year,month,0)).getDate();//身份证当月天数
  if(time>now_time||date>dates){
    return {'status':0,'msg':'出生日期不合规'}
  }
  //校验码判断
  var c = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2);   //系数
  var b = new Array('1','0','X','9','8','7','6','5','4','3','2');  //校验码对照表
  var id_array = id.split("");
  var sum = 0;
  for(var k=0;k<17;k++){
    sum+=parseInt(id_array[k])*parseInt(c[k]);
  }
  if(id_array[17].toUpperCase() != b[sum%11].toUpperCase()){
    // return {'status':0,'msg':'身份证校验码不合规'}
    return false;
  }
  // return {'status':1,'msg':'校验通过'}
  return true;
}
export default {
  verifyIDCard: verifyIDCard,
  verifyName: verifyName,
  verifyPhone: verifyPhone,
  verifyCheckCode: verifyCheckCode,
  verifyPureNum: verifyPureNum
}



// WEBPACK FOOTER //
// ./src/common/utils.js